<template>
  <div>
    <b-overlay :show="loading">
      <b-alert
        variant="secondary"
        :show="showSaveOption"
        class="mb-0"
      >
        <div class="alert-body">
          <feather-icon
            icon="InfoIcon"
            class="mr-50"
          />
          ¿Desea guardar su tarjeta de manera segura para agilizar futuros pagos?
          <b-form-checkbox
            v-model="saveNewCard"
            switch
            inline
            class="ml-1 custom-control-primary"
            @input="saveCard"
          />
        </div>
      </b-alert>

      <b-card
        v-if="savedCards.length > 0"
        no-body
        class="mt-2"
      >
        <b-card-header class="pb-1">
          <h5 class="mb-0">
            Tarjetas Guardadas
          </h5>
        </b-card-header>
        <b-card-body class="pt-2">
          <b-form-radio-group
            v-model="selectedCard"
            stacked
          >
            <b-list-group flush>
              <b-list-group-item
                v-for="card in savedCards"
                :key="card.id"
                class="d-flex align-items-center cursor-pointer"
                @click="selectCard(card)"
              >
                <b-form-radio
                  :value="card.id"
                  class="mr-2"
                />
                <div class="d-flex align-items-center w-100">
                  <b-avatar
                    :variant="getCardBrand(card.brand).variant"
                    class="mr-2"
                  >
                    <feather-icon
                      :icon="getCardBrand(card.brand).icon"
                      size="18"
                    />
                  </b-avatar>
                  <div class="w-100">
                    <h6 class="mb-0">
                      {{ card.brand }}: {{ card.number }}
                    </h6>
                    <small class="text-muted">Expira: {{ card.expiration }}</small>
                  </div>
                  <b-button
                    variant="outline-danger"
                    size="sm"
                    class="ml-auto"
                    @click.stop="confirmDelete(card)"
                  >
                    <feather-icon
                      icon="TrashIcon"
                      size="16"
                    />
                  </b-button>
                </div>
              </b-list-group-item>
            </b-list-group>
          </b-form-radio-group>
        </b-card-body>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BAlert,
  BAvatar,
  BButton,
  BCard,
  BCardBody,
  BCardHeader,
  BFormCheckbox,
  BFormRadio,
  BFormRadioGroup,
  BListGroup,
  BListGroupItem,
  BOverlay,
} from 'bootstrap-vue'

export default {
  components: {
    BOverlay,
    BAlert,
    BAvatar,
    BButton,
    BCard,
    BCardBody,
    BCardHeader,
    BFormCheckbox,
    BFormRadio,
    BFormRadioGroup,
    BListGroup,
    BListGroupItem,
  },
  props: {
    idcontrato: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      showSaveOption: true,
      saveNewCard: false,
      savedCards: [],
      selectedCard: null,
      loading: false,
    }
  },
  created() {
    this.fetchSavedCards()
  },
  methods: {
    async fetchSavedCards() {
      try {
        this.loading = true
        const response = await this.$http.get('/card', {
          params: {
            contract_id: this.idcontrato,
            user_id: this.userData.id,
          },
        })
        this.savedCards = response.data.data ?? []
      } catch (error) {
        console.error('Error fetching saved cards:', error)
      } finally {
        this.loading = false
      }
    },
    saveCard() {
      this.$emit('saveCard', this.saveNewCard)
    },
    selectCard(card) {
      this.selectedCard = card.id
      this.$emit('cardSelected', card)
    },
    confirmDelete(card) {
      this.$swal({
        title: '¿Está seguro?',
        text: '¿Desea eliminar esta tarjeta? Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteCard(card)
        }
      })
    },
    async deleteCard(card) {
      try {
        this.loading = true
        await this.$http.delete(`/card/${card.id}`)
        this.loading = false
        await this.fetchSavedCards()
      } catch (error) {
        this.loading = false
        console.error('Error deleting card:', error)
      }
    },
    getCardBrand(brand) {
      const brands = {
        visa: { icon: 'CreditCardIcon', variant: 'primary' },
        mastercard: { icon: 'CreditCardIcon', variant: 'danger' },
        amex: { icon: 'CreditCardIcon', variant: 'success' },
        default: { icon: 'CreditCardIcon', variant: 'secondary' },
      }

      return brands[brand.toLowerCase()] || brands.default
    },
  },
}
</script>
